import { useEffect } from 'react'
import '@/style/systemCert.scss'
import PageHero from '@/components/PageHero'
import Reveal from '@/components/Reveal'
import heroImg from '@/images/site/hero-cert.webp'
import certQuality from '@/images/systemCert/质量管理体系认证证书.jpg'
import certEnvironment from '@/images/systemCert/环境管理体系认证证书.jpg'
import certOccupational from '@/images/systemCert/职业健康安全管理体系认证证书.jpg'

const CERTS = [
  { icon: certQuality, title: '质量管理体系认证证书', en: 'Quality Management System' },
  { icon: certEnvironment, title: '环境管理体系认证证书', en: 'Environmental Management System' },
  { icon: certOccupational, title: '职业健康安全管理体系认证证书', en: 'Occupational Health & Safety' },
]

function SystemCert() {
  useEffect(() => {
    const type = new URLSearchParams(window.location.search).get('type')
    if (!type) return
    document.getElementById(type)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <>
      <PageHero
        eyebrow="Certification"
        title="体系认证"
        image={heroImg}
        stat={[{ value: '3', label: '体系认证' }]}
      />

      <section className="section cert__section" id="systemCert">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Certificates</p>
            <h2 className="secHead__title">体系认证</h2>
          </Reveal>

          <div className="cert__grid">
            {CERTS.map((item, i) => (
              <Reveal key={item.title} delay={i * 110}>
                <figure className="certCard">
                  <div className="certCard__media">
                    <img src={item.icon} alt={item.title} loading="lazy" />
                  </div>
                  <figcaption className="certCard__body">
                    <h3 className="certCard__title">{item.title}</h3>
                    <p className="certCard__en">{item.en}</p>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default SystemCert